var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modalWrapper",
      staticClass: "modal-wrapper new-modal-wrapper",
      attrs: { tabindex: "0", role: "dialog" },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.handleClick($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal", attrs: { role: "document" } },
        [
          _c(
            "button",
            {
              staticClass: "btn btn--close btn--close-big",
              class: {
                "modal_color-office":
                  _vm.categoryProps === _vm.config.rootcategories.biuro
              },
              on: { click: _vm.handleClick }
            },
            [_c("span"), _c("span")]
          ),
          _vm._v(" "),
          _vm._t("header", [
            _c("header", { staticClass: "modal__header" }, [
              _c("h3", {
                staticClass: "modal__title",
                domProps: { innerHTML: _vm._s(_vm.title) }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "modal__content" },
            [_vm._t("content")],
            2
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }